/**
 * Reads the SimpleSAMLphp AuthState id from the current page URL.
 * The SPA is served at /loginuserpass?AuthState=..., so window.location
 * carries it for the page lifetime. Returns '' when absent.
 *
 * @returns {string} the AuthState id, or '' if not present
 */
export function getAuthStateFromUrl() {
  return new URLSearchParams(window.location.search).get('AuthState') || '';
}
